import types from './types';
export default {
    async setLoading({ commit }, isLoading) {
        commit(types.SET_LOADING, isLoading);
    },
    async toggleNav({ commit }) {
        commit(types.SET_TOGGLE_NAV);
    }
}